import { render } from "./TommyPaperPreview.vue?vue&type=template&id=2c1fa7cd&scoped=true"
import script from "./TommyPaperPreview.vue?vue&type=script&lang=js"
export * from "./TommyPaperPreview.vue?vue&type=script&lang=js"

import "./TommyPaperPreview.vue?vue&type=style&index=0&id=2c1fa7cd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1fa7cd"]])

export default __exports__